export default __webpack_public_path__ + "static/media/avatar.cfcda3a3.jpg";